import { isUndNullEmp } from '../../helpers/main.js';

export class Toast {
    constructor(
        _id = 0,
        _type = 0,
        _title = '',
        _message = '',
        _controller = '',
        _method = '',
        _isActive = false,
        _isAuthenticated = false,
        _register = '',
    ) {
        this.id = _id;
        this.type = _type;
        this.title = _title;
        this.message = _message;
        this.controller = _controller;
        this.method = _method;
        this.isActive = _isActive;
        this.isAuthenticated = _isAuthenticated;
        this.register = _register;
    }

    static getClassTitle = () => {
        return 'Toast - class';
    }

    static minMaxLength = (upperCase = false) => {
        if (upperCase) {
            return {
                min: {
                    //Id: 0,
                    Type: 0,
                    Title: 2,
                    Message: 2,
                    Controller: 2,
                    Method: 2,
                    IsActive: 1,
                    IsAuthenticated: 1,
                    Register: 10,
                },
                max: {
                    //Id: 0,
                    Type: 10,
                    Title: 100,
                    Message: 254,
                    Controller: 100,
                    Method: 100,
                    IsActive: 1,
                    IsAuthenticated: 1,
                    Register: 10,
                }
            };
        } else {
            return {
                min: {
                    //id: 0,
                    type: 0,
                    title: 2,
                    message: 2,
                    controller: 2,
                    method: 2,
                    isActive: 1,
                    isAuthenticated: 1,
                    register: 10,
                },
                max: {
                    //id: 0,
                    type: 10,
                    title: 100,
                    message: 254,
                    controller: 100,
                    method: 100,
                    isActive: 1,
                    isAuthenticated: 1,
                    register: 10,
                }
            };
        }
    }

    static getClass = (obj = {}, upperCase = false) => {
        if (!isUndNullEmp({ data: obj, subMethod: this.getClassTitle() })?.result) {
            if (upperCase) {
                return new Toast(
                    obj.Id,
                    obj.Type,
                    obj.Title,
                    obj.Message,
                    obj.Controller,
                    obj.Method,
                    obj.IsActive,
                    obj.IsAuthenticated,
                    obj.Register,
                );
            } else {
                return new Toast(
                    obj.id,
                    obj.type,
                    obj.title,
                    obj.message,
                    obj.controller,
                    obj.method,
                    obj.isActive,
                    obj.isAuthenticated,
                    obj.register,
                );
            }
        } else {
            return new Toast();
        }
    }
}